module.exports = __webpack_public_path__ + "static/media/Surrounding6.72682b31.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/App/pages/Home/pages/Surroundings/assets/Surrounding6.jpeg
// module id = 579
// module chunks = 0